import api from 'api'
import { CACHE_TAG_ROUTES_STOPS, CACHE_TAG_ROUTE_STOP_LISTS } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getNearestStops: build.query({
      query: ({ latitude, longitude, serviceDate, limit = 20, radiusMeters, measureIds, materialIds, actionIds, businessLines }) => ({
        url: '/api/v1/core/route/stops/nearest',
        method: 'GET',
        params: {
          latitude,
          longitude,
          serviceDate,
          limit,
          radiusMeters,
          measureIds,
          materialIds,
          actionIds,
          businessLines,
        },
      }),
      providesTags: [CACHE_TAG_ROUTES_STOPS, CACHE_TAG_ROUTE_STOP_LISTS],
    }),
  }),
})

export const { useLazyGetNearestStopsQuery } = extendedApi
